import React, { useRef } from 'react'
import classNames from 'classnames'
import { useDrop } from 'react-dnd'
import { ItemTypes } from '../../../../../data/constants'
import useOnLongDragOver from '../../hooks/useOnLongDragOver'
import { handleNavigationKeys } from '../../helpers/handleNavigationKeys'

const RIGHT = 'ArrowRight'
const LEFT = 'ArrowLeft'

export type SectionHeaderProps = {
  className?: string
  sectionId: string
  label: React.ReactNode
  onToggleExpand: (sectionId: string) => void
  rightPart?: React.ReactNode
  isExpanded: boolean
}

export const SectionHeader = ({
  className,
  sectionId,
  label,
  onToggleExpand,
  rightPart,
  isExpanded,
}: SectionHeaderProps) => {
  const layoutRef = useRef<HTMLDivElement>(null)
  const [{ isDragOver }, drop] = useDrop({
    accept: ItemTypes.NOTE,

    collect(monitor) {
      return {
        isDragOver: monitor.isOver({ shallow: true }),
      }
    },
  })

  drop(layoutRef)

  useOnLongDragOver({
    isDragOver,
    enable: !isExpanded,
    onLongDragOver() {
      onToggleExpand(sectionId)
    },
  })

  const handleKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === LEFT || event.key === RIGHT) {
      event.preventDefault()
      onToggleExpand(sectionId)
    }

    handleNavigationKeys(event)
  }

  return (
    <div
      tabIndex={0}
      ref={layoutRef}
      className={classNames(
        'flexbox radius-normal padding-vertical-small',
        'padding-horizontal-small no-outline pointer margin-bottom-smaller',
        'background-shade-100 background-shade-50-on-focus background-shade-50-on-hover',
        className
      )}
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
      }}
      onClick={() => onToggleExpand(sectionId)}
      onKeyDown={handleKeyDown}
    >
      <div
        className="flexbox-grow shade-05 font-weight-medium font-size-large ellipsis flexbox flexbox-align-center"
        style={{ height: 20 }}
      >
        {label}
      </div>
      {rightPart}
    </div>
  )
}
